var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_banks"},[_c('img',{staticClass:"footer_banks_icon",attrs:{"src":"/banks/mir.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"footer_banks_icon",attrs:{"src":"/banks/verifiedvisalight.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"footer_banks_icon",attrs:{"src":"/banks/mastercard.png","alt":""}})])
}]

export { render, staticRenderFns }